export const ru = {
    emptyPrice: 'не задана'
};
